import ajax from "../helpers/ajax";
import { EndpointModel } from "../types";

class EndpointService {
  static async fetch(
    mainApiEndpoint: string,
    siteId: number
  ): Promise<EndpointModel> {
    return await ajax({
      url: `${mainApiEndpoint}/v1/${siteId}/Endpoints`,
      method: "get"
    });
  }
}

export default EndpointService;
